import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-scroll-section"]
const _hoisted_2 = { class: "pictures-wrap" }
const _hoisted_3 = ["data-scroll-speed"]
const _hoisted_4 = ["src"]

import { ref, onMounted, nextTick } from 'vue';
  import locomotiveScroll from 'locomotive-scroll';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPage',
  props: {
    pictures: null,
    logo: null,
    scrollContainer: { type: Boolean }
  },
  emits: ["rendered"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'rendered',): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    pictures: string[];
    logo?: string;
    scrollContainer?: boolean;
  };

  

  

  const reOrderArray = (value:number, element: string[]): {line: string[], element: string[]}  => {
    //fill up to have at least same length
    if (element.length < value) {
      const difference = element.length + Math.ceil(value / element.length);
      for (let i = 0; i < difference; i++){
        element.push(element[i % element.length]);
      }
    }
    // get first #value elements
    const line = element.slice(0, 8);
    element = element.slice(8);
    element = element.concat(line);
    return {line: line, element: element};
  }

  const linePictures = ref<string[][]>([[], [], [], []])
  let pictures = [ ...props.pictures];
  const initPicLines = () => {
    for (let i = 0; i < linePictures.value.length; i++) {
      const result = reOrderArray(8, pictures);
      linePictures.value[i] = result.line;
      pictures = result.element;
    }
  }
  initPicLines();
  

  const localeScrollContainer = ref(null);
  const scroll = ref<any>();
  const scrollIns = null; // eslint-disable-line

  const initLocoScroll = () => {
    scroll.value = new locomotiveScroll({
      el: localeScrollContainer.value,
      smooth: true,
      smoothMobile: true,
      getDirection: true,
    });
  }

  onMounted(() => {
    if (props.scrollContainer){
      nextTick(() => {initLocoScroll()})
    }


    // all elements loaded
    nextTick(() => {
      window.addEventListener('load', () => {
        emit('rendered');
      })
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    ref_key: "localeScrollContainer",
    ref: localeScrollContainer,
    id: "landing",
    style: _normalizeStyle(props.scrollContainer ? 'min-height: 200vh;' : '')
  }, [
    _createElementVNode("section", null, [
      _createElementVNode("div", {
        "data-scroll-section": props.scrollContainer
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linePictures.value, (line, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              "data-scroll": "",
              "data-scroll-speed": index%2 === 0 ? 2 : -2,
              "data-scroll-direction": "horizontal"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (pic, picIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index + picIndex,
                  class: _normalizeClass('picture-line-image line-' + index),
                  style: _normalizeStyle(`background-image: url('${require('@/assets/media/images/' + pic)}')`)
                }, null, 6))
              }), 128))
            ], 8, _hoisted_3))
          }), 128))
        ]),
        (props.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require('@/assets/media/logos/' + props.logo),
              alt: "Logo",
              "data-scroll": "",
              "data-scroll-speed": "5"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1)
    ]),
    _renderSlot(_ctx.$slots, "content")
  ], 4))
}
}

})